import React from 'react';
import { connect } from 'react-redux';
import TranslationService from "../../../app/services/TranslationService";
import Bloobs from "../../Bloobs";
import {config} from "../../../app/config";
import { marked } from "marked";
import {WavingTriangle} from "../../WavingTriangle";
import TypingMarkdown from "./TypingMarkdown";
import {Link} from "./Link";


export class TalkClass extends React.Component {
    imgPreviews = {};

    /**
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            screenType: this.getScreenType(),
            imgPreviews: 0
        }
    }

    componentDidMount() {
        let objDiv = document.getElementById("system-talk-preview");
        if (objDiv) {
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.screenType !== this.getScreenType()) {
            this.setState({screenType: this.getScreenType()});
        }

        let objDiv = document.getElementById("system-talk-preview");
        if (objDiv) {
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }

    getScreenType = () => {
        return localStorage.getItem('talk_screen') === 'calm' ? 'calm' : 'standard';
    }

    renderMessages = () => {
        let messages = [];

        let that = this;
        let counter = this.props.messages.length - 1;

        this.props.messages.forEach(function(message, key) {
            messages.push(<div key={'q-' + key} className="imd-row message">
                <div className="imd-col-xs-10 imd-col-sm-11 imd-offset-xs-2 imd-offset-sm-1 t-query">
                    <div className="imd-border-color-140-main imd-text-accent">
                        <span dangerouslySetInnerHTML={{ __html: marked.parse(message.query) }} />
                    </div>
                </div>
            </div>);

            if (message.answer !== null) {
                if (Object.keys(that.imgPreviews).indexOf(key.toString()) === -1) {
                    that.imgPreviews[key] = false;
                }

                messages.push(<div key={'a-' + key} className="imd-row message">
                    <div className="imd-col-xs-2 imd-col-sm-1" style={{textAlign: 'right'}}>
                        { that.state.screenType === 'calm' ?
                            <span className="icymat andra imd-text-main" style={{fontSize: '30px'}} /> :
                            // <AndraContainer scale={1} style={{margin: '0', display: key === counter ? 'block' : 'none' }} />
                            <WavingTriangle size={30} lines={0} display={key === counter}/>
                        }
                    </div>
                    <div className="imd-col-xs-10 imd-col-sm-11 t-answer">
                        <div className={'imd-text-accent ' + (that.state.screenType === 'standard' ? 'icymat-ai' : 'imd-border-color-170-accent')}>
                            <div className="real-content">
                                {/*{ that.state.screenType === 'standard' ?*/}
                                {/*    <IcyMatAI size={'1.5em'} visible={message.instruction === 'ai' || message.instruction === 'img'} style={{float: 'right'}} /> :*/}
                                {/*    null*/}
                                {/*}*/}

                                {key === counter && that.props.writing ?
                                    <TypingMarkdown text={message.answer} speed={7} chunkSize={3} onTypingEnd={() => that.props.stopWritingCallback()} /> :
                                    <span dangerouslySetInnerHTML={{ __html: marked.parse(message.answer) }} />
                                }

                                {
                                    message.instruction === 'img' ?
                                        <div className={"imd-table-responsive"} style={{textAlign: 'center', marginTop: '10px'}}>
                                            <img
                                                src={message.data.startsWith('data:image') ? message.data : config.apiAddress + '/image/' + message.data + '.png'}
                                                style={that.imgPreviews[key] ? {maxWidth: '100%', cursor: 'pointer'} : {maxWidth: '90vw', maxHeight: '250px', cursor: 'pointer'}}
                                                alt={TranslationService.trans(that.props.language, 'main.image_answer', that.props.user)}
                                                onClick={() => {that.imgPreviews[key] = !that.imgPreviews[key]; that.setState({imgPreviews: that.state.imgPreviews + 1});}}
                                            />
                                        </div>:
                                        ''
                                }

                                {
                                    message.html !== null ?
                                        <div dangerouslySetInnerHTML={{ __html: message.html }} /> :
                                        ''
                                }


                                {
                                    Object.keys(message).indexOf('links') >= 0 && message.links.length > 0 ?
                                        <div className="links">{that.renderLinks(message.links)}</div> :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                </div>);
            }
        });

        return messages;
    }

    renderLinks = (links) => {
        let linkElements = [];

        links.forEach((link, key) => {
            linkElements.push(<Link address={link} key={'link-' + key} />);
        });

        return linkElements;
    }

    render() {
        return (
            <div className={'imd-container-fluid talk' + (this.state.screenType === 'calm' ? ' imd-bg-transparent-black' : '')} id="system-talk-preview" style={{height: this.props.height}}>
                {this.renderMessages()}

                <div className={'thinking'}>
                    {this.props.thinking ? <Bloobs height={'50px'} /> : ''}
                    {this.props.thinking ? <span className={'icymat ai'} /> : ''}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const TalkScreen = connect(mapStateToProps, {})(TalkClass);
